<template>
  <div>
    <fin-strategy-details-overview-tab :strategy="strategy" :style="{ backgroundColor: $finColors.paleGrey}"/>

    <fin-strategy-details-instruments :class="$vuetify.breakpoint.xs ? 'pt-4' : 'pt-12'"
                                      :asset-class-id="assetClassId"
                                      v-if="!overviewOnly"
                                      :strategy="strategy"/>

  </div>
</template>

<script>
import FinStrategyDetailsOverviewTab from "@/components/pages/finStrategy/details/tabs/overview"
import FinStrategyDetailsInstruments from "@/components/pages/finStrategy/details/tabs/overview/instruments"
import AssetClasses from "@/mocks/AssetClasses"

export default {
  name: "finStrategyEtfDetails",
  components: {FinStrategyDetailsOverviewTab, FinStrategyDetailsInstruments},
  props: {
    strategy: {
      type: Object,
      default: undefined
    },
    /** Only display the first part of the strategy details page. Needed because of onboarding */
    overviewOnly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      assetClasses: AssetClasses.items
    }
  },
  computed: {
    assetClassId() {
      let index = this.assetClasses.slice(1).findIndex((item) => {
        if (this.strategy.id.includes("ETF_EQUITY")) {
          return item.id === 'SHARE_ETF'
        } else {
          return this.strategy.id.includes(item.id.replace("_ETF", "").trim())
        }
      })
      return index !== -1 ? this.assetClasses.slice(1)[index].id : undefined
    }
  }
}
</script>

<style scoped>

</style>
